export const formatRows = (listaItems, tipovista = "completo") =>
  listaItems.map((item, index) => {
    const base = {
      id: item.artic_deposito_id || `row-${index}`,
      idarticulo: item.id || "Información no disponible",
      codigo: item.codigo || "Información no disponible",
      descripcion: item.descripcion || "Información no disponible",
    };

    switch (tipovista) {
      case "simple":
        return base;

      case "conCosto":
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
        };

      case "mayoristaMinorista":
        return {
          ...base,
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.precio_venta ?? "Información no disponible",
        };

      case "todosPrecios":
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.precio_venta ?? "Información no disponible",
        };

      case "conStock":
        return {
          ...base,
          stock: item.stock ?? "0",
          reserva: (item.reservalocal + item.reserva )?? "0",
          disponible:(item.stock - (item.reservalocal + item.reserva) )?? "0",
        };

      default:
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.precio_venta ?? "Información no disponible",
          stock: item.stock ?? "Información no disponible",
        };
    }
  });

export const formatRowsImpresion = (listaItems, tipovista = "completo") =>
  listaItems.map((item, index) => {
    const base = {
      id: item.artic_deposito_id || `row-${index}`,
      idarticulo: item.id || "Información no disponible",
      codigo: item.codigo || "Información no disponible",
      descripcion: item.descripcion || "Información no disponible",
    };

    switch (tipovista) {
      case "simple":
        return base;

      case "conCosto":
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
        };

      case "mayoristaMinorista":
        return {
          ...base,
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.precio_venta ?? "Información no disponible",
        };

      case "todosPrecios":
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.precio_venta ?? "Información no disponible",
        };

      case "conStock":
        return {
          ...base,
          stock: item.stock ?? "0",
          reservalocal: item.reservalocal ?? "0",
          reserva: item.reserva ?? "0",
        };

      default:
        return {
          ...base,
          preciocosto: item.art_npreciocosto ?? "Información no disponible",
          preciomayorista: item.art_npreciomayorista ?? "Información no disponible",
          preciominorista: item.precio_venta ?? "Información no disponible",
          stock: item.stock ?? "Información no disponible",
        };
    }
  });